var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home--frame",style:(_vm.homeFrameStyle)},[_c('div',{staticClass:"home--frame__before",style:(_vm.beforeStyle)}),_c('div',{staticClass:"home--frame__after",style:(_vm.afterStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }